// INTEL CONFIDENTIAL
// Copyright (C) 2023 Intel Corporation

import React from 'react'
import './Announcement.scss'

export interface ActionItem {
  label: string
  redirectTo: string
}

export interface AnnouncementProps {
  title?: string
  text?: string
  action: ActionItem
}

const Announcement: React.FC<AnnouncementProps> = ({ title, text, action }): JSX.Element => {
  return (
    <div className="announcements-container gap-s4 px-s5 py-s7">
      <div className="internal-container flex-md-row px-s9 py-s5 gap-s8">
        <div className="title gap-s4">
          <h3 className="h4 text-wrap">{title}</h3>
          <span className="align-self-strech text-wrap">
            {text}{' '}
            <a className="d-inline-block link" href={action.redirectTo}>
              {action.label}
            </a>
          </span>
        </div>
      </div>
    </div>
  )
}

export default Announcement
